/** Width over height of a damage gem: a little flatter than round, as glass gems sit (Card/gemLayout). */
export const GEM_SHAPE = 1.1;
